exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__criteriaColumn___1tppM input[type=text][readonly]{border:none}.styles__criteriaColumn___1tppM textarea{border:none;overflow:auto;outline:none;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;resize:none}", ""]);

// Exports
exports.locals = {
	"criteriaColumn": "styles__criteriaColumn___1tppM"
};